export enum TeachingMethods {
  VirtueltKlasserom = "virtuelt klasserom",
  Nettkurs = "nettkurs",
  Klasserom = "klasserom",
  KombinertUndervisning = "kombinert undervisning",
}
